import React from "react";
import { useWatch } from "react-hook-form";
import { Grid } from "@mui/material";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { useParams } from "react-router";

export default function General() {
  const minCount = useWatch("min_count");
  const params = useParams();

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <FormTextTC name={"name"} tDefault={"Option group name"} tKey={"optionGroups.name"} />
            </Grid>
            <Grid container spacing={1}>
              <FormSwitchTC
                defaultValue={true}
                name={"is_active_in_jamezz"}
                tDefault={"Is visible in Jamezz"}
                tKey={"optionGroups.is_active_in_jamezz"}
              />
              <FormSwitchTC
                defaultValue={true}
                disabled={params?.id == undefined}
                name={"is_active_in_pos"}
                tDefault={"Is visible in POS"}
                tKey={"optionGroups.is_active_in_pos"}
              />

              <FormSwitchTC
                name={"countable"}
                tDefault={"Can order multiple of each item"}
                tKey={"optionGroups.countable"}
              />
              <FormControlledInputTC
                name={"min_count"}
                rules={{
                  min: {
                    value: 0,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                tDefault={"Must order minimal number of items"}
                tKey={"optionGroups.min_count"}
                type={"number"}
              />
              <FormControlledInputTC
                name={"max_count"}
                rules={{
                  min: {
                    value: minCount,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                tDefault={"Can order maximal number of items"}
                tKey={"optionGroups.max_count"}
                type={"number"}
              />
              <FormControlledInputTC
                name={"show_max_number_of_items"}
                rules={{
                  min: {
                    value: 0,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                tDefault={"Show maximal number of items at once: (0 = all)"}
                tKey={"optionGroups.show_max_number_of_items"}
                type={"number"}
              />

              <FormControlledInputTC
                name={"sort_key"}
                tDefault={"Default sort key"}
                tKey={"optionGroups.sort_key"}
                type={"number"}
              />

              <FormSwitchTC name={"skip"} tDefault={"Skip (only kiosk)"} tKey={"optionGroups.skip"} />
            </Grid>
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  );
}
